
import { AppService } from "app/services/app.service";
import { AppFilter } from "app/models/app-filter.model";
import { Pageable } from "app/models/pageable-mode";
import { Pessoa } from "app/models/pessoa.model";
import { Veiculo } from "app/models/veiculo.model";
import { BehaviorSubject, Observable } from "rxjs";

export abstract class AbVeiculo extends AppService {

  abstract pageable: Pageable;
  abstract filter: AppFilter;
  abstract pessoa: Pessoa;
  abstract veiculo: Veiculo;
  abstract pessoas: BehaviorSubject<Array<Pessoa>>;
  abstract deletarVeiculo(id: number);
  abstract getVeiculo(id: number);
  abstract saveVeiculo(veiculo);
  abstract getAllVeiculosUnidade(filter: AppFilter);
  abstract getAllVeiculosPessoaUnidade(pessoaUnidadeId: number): Observable<any>;
  abstract getAllVeiculosVinculadosUnidade(unidadeId: number): Observable<any>;
  abstract getAllVeiculosVinculadosPessoaUnidadesDaPessoa(): Observable<any>;
  abstract getAllVeiculosPessoa(pessoaId: number): Observable<any>;
  abstract getAllMarcasVeiculos(pessoaUnidadeId: number, tipoVeiculo: String): Observable<any>;
  abstract getMarcasVeiculosPessoaId(pessoaId: number, tipoVeiculo: String): Observable<any>;
}
